import React from "react"
import PropTypes from "prop-types"
import { motion, AnimatePresence } from "framer-motion"

import Header from "./header"
import Footer from "./footer"
import "./styles/layout.css"

const duration = 0.4

const contentAnimation = {
  initial: {
    opacity: 0,
    transition: {
      duration: duration,
    },
  },
  animate: {
    opacity: 1,
    transition: {
      duration: duration,
      delay: duration,
      ease: "easeInOut",
    },
  },
}

const Layout = ({ children, location, pageContext }) => {
  return (
    <>
      <Header />
      <AnimatePresence>
        <motion.main
          key={location.pathname}
          variants={contentAnimation}
          initial="initial"
          animate="animate"
          exit="initial"
        >
          {children}
        </motion.main>
      </AnimatePresence>
      {/* A case ends by handing off to the next one, so there is nowhere for a
          footer to go: it would sit past the hand-off, which takes over the
          screen before anything below it can be scrolled to. */}
      {!pageContext?.isCase && <Footer />}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
